import BadgeEntryVerificationContainer from "../../../Component/Application/BadgeEntryVerification/BadgeEntryVerificationContainer";

const BadgeEntryVerificationPage = ()  => {

    return (
        <div className="page-body">
            <BadgeEntryVerificationContainer/>
        </div>
    );
};

export default BadgeEntryVerificationPage;